module.exports = __webpack_public_path__ + "img/logo.11abc60f.png";